import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';

export enum MenuOrientation {
    STATIC,
    OVERLAY,
    HORIZONTAL
};

export class PersonalConfig {
    layoutCompact: boolean = true;
    layoutMode: MenuOrientation = MenuOrientation.STATIC;
    profileMode: string = 'inline';
    rotateMenuButton: boolean;
    topbarMenuActive: boolean;
    overlayMenuActive: boolean;
    staticMenuDesktopInactive: boolean;
    staticMenuMobileActive: boolean;

    constructor(value: Object = {}) {
        Object.assign(this,  value);
    }
}

@Injectable()
export class ConfigService {

    bs: BehaviorSubject<PersonalConfig>;

    constructor() {
        this.bs = new BehaviorSubject(null);
        let storedConfig = ConfigService.getStoredPersonalConfig();
        let personalConfig: PersonalConfig;
        if(storedConfig) {
            personalConfig = ConfigService.parsePersonalConfig(storedConfig);
        }else {
            personalConfig = new PersonalConfig();
            ConfigService.storePersonalConfig(ConfigService.encodePersonalConfig(personalConfig))
        }
        this.bs.next(personalConfig);
    }

    private static getStoredPersonalConfig(): string {
        return localStorage.getItem(environment.LSSettingsKey);
    }

    private static storePersonalConfig(value: string) : void {
        return localStorage.setItem(environment.LSSettingsKey, value);
    }

    private static parsePersonalConfig(value: string): PersonalConfig {
        return new PersonalConfig(JSON.parse(value));
    }
    private static encodePersonalConfig(config: PersonalConfig): string {
        return JSON.stringify(config);
    }


    set config(config: PersonalConfig) {
        console.log(config);
        ConfigService.storePersonalConfig(ConfigService.encodePersonalConfig(config))
        this.bs.next(config);
    }

    get config(): PersonalConfig {
        return this.bs.getValue();
    }

    get configChanges(): Observable<PersonalConfig> {
        return this.bs.asObservable();
    }

    reset() {
        this.config = new PersonalConfig();
    }

}





// WEBPACK FOOTER //
// ./src/app/personal-config/config.service.ts